module.exports = __webpack_public_path__ + "img/caixa_selecao.7efbee96.png";